<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">
<span *ngIf="$.row">{{getStatusValue( $.row.status)}}</span>
</ng-container>
